export enum Events {
  Draft = 0,
  Pending = 1,
  Approved = 2,
  ReturnForCorrection = 3,
  Rejected = 4,
  Cancelled = 5,
  Closed = 6,
  Published = 7,
}

export enum Booking {
  Draft = 1,
  Pending = 2,
  Approved = 3,
  Rejected = 4,
  ReturnForCorrection = 5,
  Confirmed = 6,
  Canceled = 7,
}
export enum Assets {
  Draft = 1,
  Active = 2,
  InActive = 3,
}

export enum Jobs {
  Draft = 1,
  Open = 2,
  Closed = 3,
}

export enum Packages {
  Active = 1,
  InActive = 0,
}
export enum Memberships {
  Draft = 1,
  Pending = 2,
  PendingForPayment = 3,
  Rejected = 4,
  Expired = 6,
  Cancelled = 7,
  Active = 9,
  InActive = 10,
}

export enum MembershipsTransfer {
  Canceled = 0,
  New = 1,
  Active = 2,
  Rejected = 3,
  Approved = 4,
  Inactive = 5,
}

export enum TransferMemberReviewStageStatus {
  Done = 1,
  Pending = 2,
  Canceled = 3,
  Approved = 4,
  Rejected = 5,
}

export enum Volunteers {
  Draft = 1,
  Open = 2,
  Closed = 3,
}

export enum Competitions {
  Draft = 1,
  Pending = 3,
  Approved = 4,
  Rejected = 5,
  ReturnForCorrection = 6,
  Published = 7,
  Closed = 8,
  Completed = 9,
}

export enum NewCompetitions {
  Pending = 0,
  Open = 1,
  Closed = 2,
  Completed = 3,
}
export enum NewCompetitionsParticipant {
  Draft = 1,
  Submitted = 2,
  CoordinatorFinalReview = 3,
  PendingAdditionalInfo = 4,
  CoordinatorApproved = 5,
  CoordinatorRejected = 6,
  JudgeReview = 7,
  JudgeApproved = 8,
  JudgeRejected = 9,
  JudgePendingAdditionalInfo = 10,
  Audit = 11,
  AuditApproved = 12,
  AuditRejected = 13
}


export enum CompetitionsCriteria {
  Active = 1,
  InActive = 2,
}

export enum DonationsGiftCardCategories {
  Active = 1,
  InActive = 2,
}

export enum DonationsGiftCardTemplates {
  Active = 1,
  InActive = 2,
}

export enum DonationTransactionStatus {
  None = 0,
  Pending = 1,
  // In Progress with tahseel
  InProgress = 2,
  // Done in tahseel
  Paid = 3,
  // Cancelled by tahseel or user
  Failed = 4,
}

export enum DonationDeliveryMethods {
  None = 0,
  Download = 1,
  Email = 2,
}

export enum PaymentStatus {
  NotPaid = 1,
  Paid = 2,
  none = 3,
}

export enum JobsApplication {
  Draft = 1,
  Pending = 2,
  Fit = 3,
  NotFit = 4,
  Closed = 5,
}
export enum VolunteerApplication {
  Draft = 1,
  Pending = 2,
  Fit = 3,
  NotFit = 4,
  Closed = 5,
}
